import apiInstance from "../Api/ApiInstance";

export async function SendMessagesEmail(value) {
  return await apiInstance.post(`api/official-site/email`, value);
}
